import type { SelectModel, SelectModelEntry } from '@/models/utils'

export enum OperandType {
  '>',
  '<',
  '>=',
  '<=',
  '='
}

export const largerOperands: SelectModel<OperandType> = [
  { name: '>', code: OperandType['>'] },
  { name: '>=', code: OperandType['>='] }
] as const

export const smallerOperands: SelectModel<OperandType> = [
  { name: '<', code: OperandType['<'] },
  { name: '<=', code: OperandType['<='] }
] as const

export const parseOperandIndex = (operand?: SelectModelEntry<OperandType>) => {
  if (!operand) return undefined
  const index = operands.findIndex((o) => o.name === operand.name)
  return index !== -1 ? index : undefined
}

export const toOperandModel = (operand?: OperandType) => operands.find((o) => o.code === operand)

export const operands: SelectModel<OperandType> = [
  { name: '>', code: OperandType['>'] },
  { name: '<', code: OperandType['<'] },
  { name: '>=', code: OperandType['>='] },
  { name: '<=', code: OperandType['<='] }
] as const
